import i18n from '../i18n'
import { WARRANTY_PRODUCT_SKU } from 'Utils/constants'
import { getDummyLitaDescription, isDummyLitaProduct } from 'Utils/functions'

export const getProductDisplayText = product => {
  if (!product) return ''

  const isWarranty =
    product.IsExtendedWarranty ||
    product.Sku === WARRANTY_PRODUCT_SKU ||
    product.SystemCode === WARRANTY_PRODUCT_SKU

  if (isWarranty && product.WarrantyYears) {
    const title = i18n.t('EXTENDED_WARRANTY_T.TITLE_CARD_PRODUCT', {
      warrantyYears: product.WarrantyYears,
    })
    const plural = product.WarrantyYears > 1 ? 's' : ''
    const reference = product.Reference || ''

    return `${title}${plural}\n${reference}`
  }

  if (isDummyLitaProduct(product)) {
    return getDummyLitaDescription(product)
  }

  return product.ProductName || ''
}
